import React,{ useState, useEffect } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import { BiPlus } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { getUserList, getSingleUserDetails, deleteUser } from '../../redux/actions/AuthActions';
import { connect } from 'react-redux';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import UsersList from './components/UsersList';
import TableFilter from './components/TableFilter';
import UserDetailsModel from './components/model/UserDetailsModel';
import { CSVLink } from 'react-csv';
import { FiDownload } from 'react-icons/fi';



const UserListScreen = ({ getUserList, userList, getSingleUserDetails, deleteUser, authDelete }) => {

    const { loading, users, error } = userList;

    const { success } = authDelete;


    const [filterData, setFilterData] = useState([]);

    
    useEffect(() => {
        getUserList()
    }, [getUserList, success])


    const [rowLimit , setRowLimit] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);

    const rowHandler = (e) => {
        const { value } = e.target;
        setRowLimit(value)
    }

    const indexOfLastData = currentPage * rowLimit;
    const indexOfFirstData = indexOfLastData - rowLimit;
    const userData = users.slice(indexOfFirstData, indexOfLastData)
    const filterUserData = filterData.slice(indexOfFirstData, indexOfLastData)
    
   
    const searchHandler = (e) => {
        if (e.target.value !== '') {
            const filter = users.filter(item => {
                return Object.values(item).join('').toLowerCase().includes(e.target.value.toLowerCase()) 
            })
            setFilterData(filter)
        }else{
            setFilterData(users)
        }
    }

    const [profileModel, setProfileModel] = useState(false)

    const viewUserDetails = (id) => {
        setProfileModel(!profileModel)
        getSingleUserDetails(id);
    }
    
    
    const userDeleteHandler = (id) => {
        if (window.confirm(`Are you sure, you want delete ${id}!`)) {
            deleteUser(id)
        }
    }


    const headers = [
        { label: "ID", key: "_id" },
        { label: "Name", key: "name" },
        { label: "Email", key: "email" },
        { label: "Phone", key: "phone" },
        { label: "Role", key: "role" },
        { label: "CreatedAt", key: "createdAt" },
        { label: "UpdatedAt", key: "updatedAt" },
    ];


    return (
        <div className='relative bg-gray-50 min-h-screen'>
            <UserDetailsModel profileModel={profileModel} setProfileModel={setProfileModel}  />
            <SideBar />
            <MobileNav />
            <Header />
            <div className='md:ml-72 px-4 md:px-2'>
                <div className='my-6 text-3xl font-bold tracking-wide uppercase md:text-center'>
                    users
                </div>
                <div className='flex justify-between items-center flex-col md:flex-row'>
                    <div className='flex items-center shadow py-2 px-4 sen-font rounded bg-red-300 md:mr-10 mb-5 md:mb-0 w-full md:w-fit'>
                        <FiDownload />
                        <CSVLink headers={headers} data={users} filename="users.csv" className='ml-3'>Export CSV</CSVLink>
                    </div>
                        
                    <input
                        name='search'
                        type='search'
                        onChange={searchHandler}
                        placeholder='search...'
                        className="shadow-sm bg-gray-50 md:w-60 border border-gray-300 text-gray-900 text-sm rounded-lg outline-[#edf2f4] focus:ring-[#83c5be] focus:border-[#83c5be] w-full p-2.5"
                    />
                </div>

                {loading ? <Loader /> : error ? <Message error msg={error} /> : (
                    <>

                        <div className="relative overflow-x-auto my-10">
                            <table className="w-full text-sm text-left text-black ">
                                <thead className="text-xs text-black mont-font text-white uppercase bg-[#0b2545]">
                                    <tr className='border border-gray-300'>
                                        <th className="px-6 py-3 border border-gray-300">ID</th>
                                        <th className="px-6 py-3 border border-gray-300">NAME</th>
                                        <th className="px-6 py-3 border border-gray-300">EMAIL</th>
                                        <th className="px-6 py-3 border border-gray-300">PHONE</th>
                                        <th className="px-6 py-3 border border-gray-300">ROLE</th>
                                        <th className="px-6 py-3 border border-gray-300">
                                            <span className="sr-only">ACTION</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filterData.length  ? (
                                            <>
                                                {
                                                    filterUserData.map((val) => (
                                                        <React.Fragment key={val._id}>
                                                            <UsersList val={val} userDeleteHandler={userDeleteHandler} viewUserDetails={viewUserDetails}  />
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    userData.map((val) => (
                                                        <React.Fragment key={val._id}>
                                                            <UsersList val={val} userDeleteHandler={userDeleteHandler} viewUserDetails={viewUserDetails} />
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <TableFilter rowHandler={rowHandler} rowLimit={rowLimit} data={users} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userList: state.userList,
    authDelete: state.authDelete
})

export default connect(mapStateToProps,{ getUserList, getSingleUserDetails, deleteUser })(UserListScreen);